import React from 'react';

export const Wallet = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 46 46">
      <path
        stroke="#6195CC"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M9.091 18.062l-1.706-5.286a1.896 1.896 0 011.223-2.385l28.875-9.3a1.896 1.896 0 012.382 1.224l4.648 14.435a1.896 1.896 0 01-1.223 2.387l-10.06 3.24M8.841 17.288l4.283-8.35m28.198-2.113l-8.349-4.28m10.093 9.695l-4.28 8.349"
      ></path>
      <path
        stroke="#6195CC"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M28.4 9.991l-5.699 1.837a1.596 1.596 0 00.598 3.113l5.308-.354a1.596 1.596 0 01.597 3.113l-1.124.362m-3.29-6.907l-.58-1.805m9.02 25.774v5.688a3.792 3.792 0 01-3.792 3.791H4.791A3.792 3.792 0 011 40.813V21.854a3.792 3.792 0 013.792-3.792h24.645a3.792 3.792 0 013.792 3.791v5.688M6.695 18.062v26.541"
      ></path>
      <path
        stroke="#6195CC"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M26.594 27.541a3.792 3.792 0 100 7.583h6.635a1.896 1.896 0 001.896-1.896v-3.791a1.896 1.896 0 00-1.896-1.896h-6.635z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#6195CC"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M30.867 30.859a.474.474 0 110 .948.474.474 0 010-.948"
      ></path>
    </svg>
  );
};
